import { useRouter } from 'next/router'
import SERVICES from '@constants/values/serviceKinds'
import PART_KINDS from '@constants/values/partKinds'
import {
    car as CAR_TYPES,
    truck as TRUCK_TYPES,
    motorcycle as MOTO_TYPES,
} from '@constants/values/types'

import writePriceSlug from '@utils/slug/writePriceSlug'

const MOTO_MAKES = ['Aprilia', 'Benelli', 'BMW', 'Ducati', 'Harley-Davidson', 'Honda', 'Kawasaki', 'KTM', 'Moto Guzzi', 'MV Agusta', 'Peugeot', 'Piaggio', 'Super SOCO', 'Suzuki', 'Triumph', 'Ural', 'Yamaha']
const CITIES = ['Białystok', 'Bielsko-Biała', 'Bydgoszcz', 'Bytom', 'Chorzów', 'Częstochowa', 'Elbląg', 'Gdańsk', 'Gdynia', 'Gliwice', 'Gniezno', 'Gorzów Wlkp.', 'Jelenia Góra', 'Legnica', 'Leszno', 'Kalisz', 'Katowice', 'Kielce', 'Konin', 'Koszalin', 'Kraków', 'Łódź', 'Olsztyn', 'Opole', 'Poznań', 'Radom', 'Rybnik', 'Rzeszów', 'Siedlce', 'Sosnowiec', 'Szczecin', 'Toruń', 'Wałbrzych', 'Warszawa', 'Wrocław', 'Zielona Góra']
const REGIONS = [
    { coords: '14.5509623,53.4301818,100', name: 'Zachodniopomorskie' },
    { coords: '15.210755319093852,52.73057555,95', name: 'Lubuskie' },
    { coords: '16.97819633051261,51.1263106,110', name: 'Dolnosląskie' },
    { coords: '18.62821847557274,54.36143405,115', name: 'Pomorskie' },
    { coords: '18.62821847557274,54.36143405,115', name: 'Kujawsko-pomorskie' },
    { coords: '16.91973259178088,52.4006632,100', name: 'Wielkopolskie' },
    { coords: '17.929884436033525,50.678792900000005,80', name: 'Opolskie' },
    { coords: '19.0215852,50.2598987,70', name: 'Śląskie' },
    { coords: '19.997153435836697,50.0469432,75', name: 'Małopolskie' },
    { coords: '22.009911525182105,50.00715125,75', name: 'Podkarpackie' },
    { coords: '22.554677565192677,51.218194499999996,85', name: 'Lubelskie' },
    { coords: '21.0067249,52.2319581,85', name: 'Mazowieckie' },
    { coords: '23.147050870161664,53.127505049999996,85', name: 'Podlaskie' },
    { coords: '20.477781292210345,53.7767239,80', name: 'Warmińsko-mazurskie' },
    { coords: '19.4569911,51.7687323,70', name: 'Łódzkie' },
    { coords: '20.609914352101452,50.85403585,70', name: 'Świętokrzyskie' },
]
const PRICES = [1,3,5,10,15,20,25,30,40,50,60,70,80,100,120,150]

const resolveLinkFestProps = (adType, isRent) => {
    const linkFestProps = {}
    const router = useRouter()

    if (typeof linkFestProps.customLinks === 'undefined') {
        linkFestProps.customLinks = resolveCustomLinks(isRent
            ? 'wynajem-' + adType
            : adType)
    }

    if (router) {
        const url = decodeURIComponent(router.asPath)
        linkFestProps.customLinks = [...linkFestProps.customLinks, ...resolveViaUrl(url)]
    }

    return linkFestProps.customLinks
}

function resolveCustomLinks (adType) {
    switch (adType) {
        case 'przyczepy': return trailerLinks()
        case 'agri_ad': return agriLinks()
        case 'budowlane': return constructionLinks()
        case 'service_ad': return serviceLinks()
        case 'wynajem-car_ad': return carRentLinks()
        case 'part_ad': return partLinks()
        case 'truck_ad': return truckLinks()
        case 'motorcycle_ad': return motoLinks()
        case 'car_ad': return carLinks()
    }

    return []
}

function carLinks () {
    return [{
        data: CAR_TYPES,
        title: 'Typy samochodów osobowych',
        name: (data) => `Samochody ${data}`,
        link: (data) => `/samochody-osobowe?typ-nadwozia=${encodeURIComponent(data)}`
    }]
}

function motoLinks () {
    return [{
        data: MOTO_MAKES,
        title: 'Marki motocykli',
        name: (data) => `Motocykle ${data}`,
        link: (data) => `/motocykle/${encodeURIComponent(data)}`,
    },{
        data: CITIES,
        title: 'Motocykle w miastach',
        name: (data) => `Motocykle ${data}`,
        link: (data) => `/motocykle/lokalizacja/${encodeURIComponent(data)}`,
    },{
        data: REGIONS,
        title: 'Motocykle w województwach',
        name: (data) => `Motocykle ${data.name}`,
        link: (data) => `/motocykle?wspolrzedne=${data.coords}`,
    },{
        data: MOTO_TYPES,
        title: 'Typy motocykli',
        name: (data) => `Motocykle ${data}`,
        link: (data) => `/motocykle?typ=${encodeURIComponent(data)}`
    }]
}

function truckLinks () {
    return [{
        data: CITIES,
        title: 'Samochody dostawcze w miastach',
        name: (data) => `Samochody dostawcze ${data}`,
        link: (data) => `/samochody-dostawcze/lokalizacja/${encodeURIComponent(data)}`,
    },{
        data: REGIONS,
        title: 'Samochody dostawcze w województwach',
        name: (data) => `Samochody dostawcze ${data.name}`,
        link: (data) => `/samochody-dostawcze?wspolrzedne=${data.coords}`,
    },{
        data: TRUCK_TYPES,
        title: 'Typy samochodów dostawczych',
        name: (data) => `Samochody dostawcze ${data}`,
        link: (data) => `/samochody-dostawcze?typ-nadwozia=${encodeURIComponent(data)}`
    }]
}

function partLinks () {
    return [{
        data: PART_KINDS,
        title: 'Rodzaje części samochodowych',
        name: (data) => data,
        link: (data) => `/czesci-auta-dostawcze?rodzaj-czesci=${encodeURIComponent(data)}`,
    },{
        data: CITIES,
        title: 'Części w miastach',
        name: (data) => `Części ${data}`,
        link: (data) => `/czesci-auta-dostawcze/lokalizacja/${encodeURIComponent(data)}`,
    }]
}

function carRentLinks () {
    return [{
        data: CITIES,
        title: 'Wynajem samochodów w miastach',
        name: (data) => `Wynajem samochodów ${data}`,
        link: (data) => `/wynajem/samochody-osobowe?rent=true&miejsce-odbioru=${encodeURIComponent(data)}`,
    },{
        data: CAR_TYPES,
        title: 'Wynajem samochodów',
        name: (data) => `Wynajem samochodów ${data}`,
        link: (data) => `/wynajem/samochody-osobowe?rent=true&typ-nadwozia=${encodeURIComponent(data)}`
    }]
}

function serviceLinks () {
    return [{
        data: SERVICES,
        title: 'Rodzaje usług serwisowych',
        name: (data) => data,
        link: (data) => `/serwis-aut-dostawczych?rodzaj-serwisu=${encodeURIComponent(data)}`
    },{
        data: CITIES,
        title: 'Serwis samochodów w miastach',
        name: (data) => `Autoserwis ${data}`,
        link: (data) => `/serwis-aut-dostawczych/lokalizacja/${encodeURIComponent(data)}`,
    }]
}

function constructionLinks () {
    return [{
        data: CITIES,
        title: 'Maszyny budowlane w miastach',
        name: (data) => `Maszyny budowlane ${data}`,
        link: (data) => `/maszyny-budowlane-sprzedaz/lokalizacja/${encodeURIComponent(data)}`,
    }]
}

function agriLinks () {
    return [{
        data: CITIES,
        title: 'Maszyny rolnicze w miastach',
        name: (data) => `Maszyny rolnicze ${data}`,
        link: (data) => `/maszyny-rolnicze-sprzedaz/lokalizacja/${encodeURIComponent(data)}`,
    }]
}

function trailerLinks () {
    return [{
        data: CITIES,
        title: 'Przyczepy w miastach',
        name: (data) => `Przyczepy ${data}`,
        link: (data) => `/przyczepy/lokalizacja/${encodeURIComponent(data)}`,
    }]
}

function resolveViaUrl (url) {
    if (url.lastIndexOf('&') !== -1) return []

    const carTypeRegexp = /^\/samochody-osobowe\?typ-nadwozia=(.+)$/ig
    const truckTypeRegexp = /^\/samochody-dostawcze\?typ-nadwozia=(.+)$/ig

    let match = url.match(carTypeRegexp)
    if (match) {
        const type = url.slice(32)
        if (type) {
            return [{
                data: PRICES,
                title: `Ceny samochodów ${type}`,
                name: (data) => `${type} do ${priceText(data * 1000)}`,
                link: (data) => `/samochody-osobowe?typ-nadwozia=${type}&cena-do=${writePriceSlug(data * 1000)}`
            }]
        }
    }

    match = url.match(truckTypeRegexp)
    if (match) {
        const type = url.slice(24)
        if (type) {
            return [{
                data: PRICES,
                title: `Ceny samochodów typu ${type}`,
                name: (data) => `${type} do ${priceText(data * 1000)}`,
                link: (data) => `/samochody-dostawcze?typ-nadwozia=${type}&cena-do=${writePriceSlug(data * 1000)}`
            }]
        }
    }

    return []
}

function priceText (price) {
    price = writePriceSlug(price, ' mln. ', ' tys. ', 'zł')
    return String(price).endsWith('zł')
        ? price
        : price + ' zł'
}

export default resolveLinkFestProps